import { REACT_APP_API_ENDPOINT } from "../helpers/data";
import { handleResponse, sendPostRequest } from "./apiUtilis";

export const requestContact = async (req) => {
    try {
        const response = await sendPostRequest(REACT_APP_API_ENDPOINT + "message", req);
        console.error("Response:", response);
        return handleResponse(response);
    } catch (error) {
        console.error("Error in requestContact:", error);
        throw error;  // Re-throw the error after logging it
    }
};